import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IRemoteUserDataProfilesService = ( createDecorator('IRemoteUserDataProfilesService'));
export { IRemoteUserDataProfilesService };
